module.exports = __webpack_public_path__ + "img/banner.a1e7f223.png";